function GameError() {
  return <div className="game-error"></div>;
}

export default GameError;
